import { TitleLoader } from "../Loader";
import "./styles.css";
const CardCount = (props) => {
  return (
    <div
      className="card card-count-container"
      style={{ borderTopColor: props.color, cursor: "pointer" }}
      onClick={() => (props.onPress ? props.onPress() : null)}
    >
      <div className="card-body">
        <div
          className="card-count-icon-container"
          // style={{ backgroundColor: props.color }}
        >
          <span className={process.env.REACT_APP_ICONS_TYPE}>{props.icon}</span>
        </div>
        <div className="card-count-content">
          <h1 className="count">
            {props.isLoading ? (
              <TitleLoader />
            ) : (
              <div>
                {props.count}
                {props.subCount && <small>{props.subCount}</small>}
              </div>
            )}
          </h1>
          <p>{props.title}</p>
        </div>
      </div>
    </div>
  );
};

export default CardCount;
